import type { EvaluatedToilet } from "./types";

export const MAP_CANDIDATE_LIMIT = 15;

export type RankedCandidate = {
  item: EvaluatedToilet;
  rank: number;
};

const selectedRank = (items: EvaluatedToilet[], selectedId?: string) =>
  selectedId === undefined
    ? -1
    : items.findIndex((item) => item.id === selectedId) + 1;

export function getMapCandidateEntries(
  items: EvaluatedToilet[],
  selectedId?: string,
): RankedCandidate[] {
  const entries = items
    .slice(0, MAP_CANDIDATE_LIMIT)
    .map((item, index) => ({ item, rank: index + 1 }));
  const rank = selectedRank(items, selectedId);
  if (rank > MAP_CANDIDATE_LIMIT) {
    entries.push({ item: items[rank - 1]!, rank });
  }
  return entries;
}

export function getListCandidateEntries(
  items: EvaluatedToilet[],
  selectedId?: string,
): RankedCandidate[] {
  const rank = selectedRank(items, selectedId);
  const highestMapRank = Math.max(MAP_CANDIDATE_LIMIT, rank);
  return items
    .slice(0, highestMapRank)
    .map((item, index) => ({ item, rank: index + 1 }));
}
